import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/activitylist";
import { useNavigate, useParams } from "react-router-dom";
import { ClassForLessonSelectForActivities } from "../../ui/myselect";
import { RecognitionLevelSelect, CategorySelectForActivity, PositionSelectForActivity } from '../../ui/myselect'
import { useAuth } from '../../../usercontext'
import STopMenu from '../../../components/student/topmenu/topmenu'
import S911TopMenu from '../../student911/topmenu/topmenu'
import S12TopMenu from '../../student12/topmenu/topmenu'

export default function StudentActivityEdit() {
	const [gradelevel, setGradelevel] = useState()
	const [hoursperweek, setHoursperweek] = useState()
	const [weeksperyear, setWeeksperyear] = useState()
	const [recoglevel, setRecoglevel] = useState()
	const [sortOrder, setSortOrder] = useState(0)
	const [category, setCategory] = useState()
	const [position, setPosition] = useState()
  const [description, setDescription] = useState()
	const [data, setData] = useState([])
	const { profile } = useAuth()

	const navigate = useNavigate()
	let { slug, Id } = useParams()
	const studentId = profile.id

	async function GetData() {
		//data
		const organizationData = await getIdData(Id)
		console.log('parameterData', organizationData[0])
		setData(organizationData)
		setDescription(organizationData[0].description)
		setCategory(organizationData[0].category)
		setPosition(organizationData[0].position)
		setGradelevel(organizationData[0].gradelevel)
		setRecoglevel(organizationData[0].recoglevel)
		setHoursperweek(organizationData[0].hoursperweek)
		setWeeksperyear(organizationData[0].weeksperyear)
		setSortOrder(organizationData[0].sortorder)

		//isDisabled = {slug === "Add" ? false : true}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (slug === 'Add') {
			console.log('Add')

			await addData({
				studentId: profile.id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				hoursperweek: hoursperweek,
				weeksperyear: weeksperyear,
				description: description,
				category: category,
				position: position,
				sortorder: sortOrder
			})
		} else {
			console.log('Update')
			await updateData({
				id: Id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				hoursperweek: hoursperweek,
				weeksperyear: weeksperyear,
				description: description,
				category: category,
				position: position,
				sortorder: sortOrder
			})
		}

		navigate(-1)
	}

	useEffect(() => {
		if (slug === 'Update') {
			GetData()
		}
	}, [slug])
	const isStudent911 = profile?.role === 'Student911'
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	const grade = profile?.role.toLowerCase()
	return (
		<>
			{isStudent && <STopMenu slug={studentId} activeMenu="LessonsEdit" />}
			{isStudent911 && <S911TopMenu slug={studentId} activeMenu="LessonsEdit" />}
			{isStudent12 && <S12TopMenu slug={studentId} activeMenu="LessonsEdit" />}
			<div className="col-12">
				<div className="settings-widget profile-details">
					<div className="settings-menu p-2">
						<div className="profile-heading P-2">
							<h3>{slug === 'Add' ? 'Add Activity' : 'Update Activity'}</h3>
						</div>
						<div className="checkout-form personal-address add-course-info ">
							<form role="form" onSubmit={handleSubmit}>
								<div className="row mx-auto">
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Grade Level</label>
											<ClassForLessonSelectForActivities value={gradelevel} name={'Grade Level'} setValue={setGradelevel} />
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Hours Per Week</label>
											<input
												type="number"
												value={hoursperweek}
												onChange={(e) => setHoursperweek(e.target.value)}
												className="form-control"
												placeholder="Hours Per Week"
												min="0"
											/>
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Weeks Per Year</label>
											<input
												type="number"
												value={weeksperyear}
												onChange={(e) => setWeeksperyear(e.target.value)}
												className="form-control"
												placeholder="Weeks Per Year"
												min="0"
											/>
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Recognition Level</label>
											<RecognitionLevelSelect value={recoglevel} setValue={setRecoglevel} />
										</div>
									</div>

									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Category</label>
											<CategorySelectForActivity value={category} setValue={setCategory} />
										</div>
									</div>

									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Position</label>
											<PositionSelectForActivity value={position} setValue={setPosition} />
										</div>
									</div>

									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Description</label>
											<textarea
												rows="4"
												value={description}
												onChange={(e) => setDescription(e.target.value)}
												className="form-control"
												placeholder="Description"
											></textarea>
										</div>
									</div>

									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Order</label>
											<input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="form-control" required />
										</div>
									</div>

									<div className="update-profile d-flex justify-content-between">
										<button type="submit" className="btn btn-primary">
											{slug === 'Add' ? 'Add Activity' : 'Update Activity'}
										</button>
										<button onClick={() => navigate(`/${grade}/student-activity`)} className="btn btn-black btn-sm">
											Cancel
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
